export default __webpack_public_path__ + "static/media/party-time.14b3e5ab.png";